export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Login.vue?vue&type=template&id=2b38f2aa&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/Login.vue?vue&type=template&id=2b38f2aa&scoped=true&
// module id = 215
// module chunks = 1